import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { push } from "connected-react-router";
import downloadFile from "../../../lib/utils/downloadFile";
import ModalActions from "../../../redux/reducers/modal.reducer";
import theme from "../../../styles/LightTheme";

/**
 * Hook para manejar acciones del historial de pagos.
 * Centraliza navegación y descarga de derechos patrimoniales.
 */
export const usePaymentHistoryActions = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleBack = useCallback(() => {
    dispatch(push("/my-payments"));
  }, [dispatch]);

  const handleDownload = useCallback(
    (payment) => {
      if (payment.equity_rights_url) {
        dispatch(
          ModalActions.setConditionalModalState(
            true,
            "ModalLoadingCertificate",
            {
              clearBlur: true,
              css: { backgroundColor: theme.transparentMartinique },
              description: t("searchInvestDetail.download")
            }
          )
        );

        downloadFile(payment.equity_rights_url, false);

        setTimeout(() => {
          dispatch(
            ModalActions.setConditionalModalState(
              false,
              "ModalLoadingCertificate"
            )
          );
        }, 3000);
      } else {
        dispatch(
          ModalActions.setConditionalModalState(true, "ErrorModal", {
            title: "Error",
            content: "No se pudo descargar el archivo de derechos patrimoniales"
          })
        );
      }
    },
    [dispatch, t]
  );

  return {
    handleBack,
    handleDownload
  };
};
